<template>
  <div>
    <HeaderMenuDesktopMenu :menu-items="menuItems" :darkMode="darkMode" class="hidden lg:block" />
    <HeaderMenuMobileMenu :menu-items="menuItems" :darkMode="darkMode" class="block lg:hidden" />
  </div>
</template>

<script setup lang="ts">
  import type { MenuItem } from '~/types/strapi';

  interface MenuLink {
    label: string;
    url?: string;
    target?: string;
  }
  export interface HeaderMenuItem {
    link: MenuLink;
    isActive?: boolean;
    hasSubItems?: boolean;
    subItems?: HeaderMenuItem[];
  }

  const props = defineProps<{
    menuItems: MenuItem[];
    darkMode: boolean;
  }>();

  const getLocalizedUrl = useLocalizedUrl();

  const menuItems = computed<HeaderMenuItem[]>(() => {
    const items: HeaderMenuItem[] = [];

    props.menuItems.forEach(item => {
      // INFO: skip items without label
      if (!item.label) return;

      const hasSubItems = !!item.subItems && item.subItems.length > 0;

      items.push({
        link: {
          label: item.label,
          url: getLocalizedUrl(item),
          target: item.target,
        },
        isActive: item.isActive,
        hasSubItems,
        subItems: hasSubItems
          ? (item.subItems || []).map(subItem => ({
              link: {
                label: subItem.label,
                url: getLocalizedUrl(subItem),
                target: subItem.target,
                isActive: subItem.isActive,
                hasSubItems: false, // sub items of sub items are not supported
                subItems: undefined, // sub items of sub items are not supported
              },
            }))
          : undefined,
      });
    });

    return items;
  });
</script>
